import { ACTIONS, LEARNING_ASSET_TYPES } from '../Constants';

const getInitialState = () => ({
    byId: {},
    archivedById: {},
    [LEARNING_ASSET_TYPES.TRACK]: {},
    [LEARNING_ASSET_TYPES.ACTIVITY]: {},
    [LEARNING_ASSET_TYPES.ARTICLE]: {},
    [LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY]: {},
    [LEARNING_ASSET_TYPES.VIDEO]: {},
    [LEARNING_ASSET_TYPES.IMPACT_PROJECT]: {},
    [LEARNING_ASSET_TYPES.ASSESSMENT]: {},
    [LEARNING_ASSET_TYPES.PRE_ASSESSMENT]: {},
    [LEARNING_ASSET_TYPES.POST_ASSESSMENT]: {},
    [LEARNING_ASSET_TYPES.FEEDBACK]: {},
    filteredById: {},
    loading: false
});

export default (state = getInitialState(), action) => {
    let newById;
    let reduced;
    let newArchivedById;
    switch (action.type) {
        case ACTIONS.GET_MANY_LEARNING_ASSETS_START: {
            return {
                ...state,
                loading: true
            };
        }
        case ACTIONS.GET_MANY_LEARNING_ASSETS: {
            const newByType = {
                [LEARNING_ASSET_TYPES.TRACK]: { ...state[LEARNING_ASSET_TYPES.TRACK] },
                [LEARNING_ASSET_TYPES.ACTIVITY]: { ...state[LEARNING_ASSET_TYPES.ACTIVITY] },
                [LEARNING_ASSET_TYPES.ARTICLE]: { ...state[LEARNING_ASSET_TYPES.ARTICLE] },
                [LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY]: { ...state[LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY] },
                [LEARNING_ASSET_TYPES.VIDEO]: { ...state[LEARNING_ASSET_TYPES.VIDEO] },
                [LEARNING_ASSET_TYPES.IMPACT_PROJECT]: { ...state[LEARNING_ASSET_TYPES.IMPACT_PROJECT] },
                [LEARNING_ASSET_TYPES.ASSESSMENT]: { ...state[LEARNING_ASSET_TYPES.ASSESSMENT] },
                [LEARNING_ASSET_TYPES.PRE_ASSESSMENT]: { ...state[LEARNING_ASSET_TYPES.PRE_ASSESSMENT] },
                [LEARNING_ASSET_TYPES.POST_ASSESSMENT]: { ...state[LEARNING_ASSET_TYPES.POST_ASSESSMENT] },
                [LEARNING_ASSET_TYPES.FEEDBACK]: { ...state[LEARNING_ASSET_TYPES.FEEDBACK] }
            };

            newById = {
                ...state.byId
            };

            action.payload.learningAssets.forEach((learningAsset) => {
                if (learningAsset._id in newById) {
                    newById[learningAsset._id] = {
                        ...newById[learningAsset._id],
                        ...learningAsset
                    };
                } else {
                    newById[learningAsset._id] = learningAsset;
                }

                if (learningAsset.type in newByType && !(learningAsset._id in newByType[learningAsset.type])) {
                    newByType[learningAsset.type][learningAsset._id] = learningAsset._id;
                }
            });

            return {
                ...state,
                ...newByType,
                byId: newById,
                loading: false
            };
        }

        case ACTIONS.GET_LEARNING_ASSET:
        case ACTIONS.PUT_LEARNING_ASSET_SUCCESS:
        case ACTIONS.POST_LEARNING_ASSET_SUCCESS: {
            const { learningAsset } = action.payload;
            newById = {
                ...state.byId
            };

            if (learningAsset._id in newById) {
                newById[learningAsset._id] = {
                    ...newById[learningAsset._id],
                    ...learningAsset
                };
            } else {
                newById[learningAsset._id] = learningAsset;
            }

            const newByType = { ...state[learningAsset.type] };
            if (!(learningAsset._id in newByType)) {
                newByType[learningAsset._id] = learningAsset._id;
            }

            return {
                ...state,
                [learningAsset.type]: newByType,
                byId: newById,
                loading: false
            };
        }

        case ACTIONS.GET_FILTERED_LEARNING_ASSETS: {
            const newByType = {
                [LEARNING_ASSET_TYPES.TRACK]: { ...state[LEARNING_ASSET_TYPES.TRACK] },
                [LEARNING_ASSET_TYPES.ACTIVITY]: { ...state[LEARNING_ASSET_TYPES.ACTIVITY] },
                [LEARNING_ASSET_TYPES.ARTICLE]: { ...state[LEARNING_ASSET_TYPES.ARTICLE] },
                [LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY]: { ...state[LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY] },
                [LEARNING_ASSET_TYPES.VIDEO]: { ...state[LEARNING_ASSET_TYPES.VIDEO] },
                [LEARNING_ASSET_TYPES.IMPACT_PROJECT]: { ...state[LEARNING_ASSET_TYPES.IMPACT_PROJECT] },
                [LEARNING_ASSET_TYPES.ASSESSMENT]: { ...state[LEARNING_ASSET_TYPES.ASSESSMENT] },
                [LEARNING_ASSET_TYPES.PRE_ASSESSMENT]: { ...state[LEARNING_ASSET_TYPES.PRE_ASSESSMENT] },
                [LEARNING_ASSET_TYPES.POST_ASSESSMENT]: { ...state[LEARNING_ASSET_TYPES.POST_ASSESSMENT] },
                [LEARNING_ASSET_TYPES.FEEDBACK]: { ...state[LEARNING_ASSET_TYPES.FEEDBACK] }
            };

            const { learningAssets } = action.payload;
            reduced = learningAssets.reduce((prev, learningAsset) => {
                if (learningAsset._id in state.byId) {
                    prev[learningAsset._id] = {
                        ...state.byId[learningAsset._id],
                        ...learningAsset
                    };
                } else {
                    prev[learningAsset._id] = learningAsset;
                }

                if (learningAsset.type in newByType && !(learningAsset._id in newByType[learningAsset.type])) {
                    newByType[learningAsset.type][learningAsset._id] = learningAsset._id;
                }

                return prev;
            }, {});

            newById = {
                ...state.byId,
                ...reduced
            };

            return {
                ...state,
                ...newByType,
                byId: newById,
                filteredById: reduced,
                loading: false
            };
        }

        case ACTIONS.PUT_ARCHIVED_LEARNING_ASSET_SUCCESS: {
            const { learningAsset } = action.payload;
            newById = {
                ...state.byId
            };

            newArchivedById = {
                ...state.archivedById,
                [learningAsset._id]: learningAsset
            };

            const newFilteredById = {
                ...state.filteredById
            };

            const newByType = { ...state[learningAsset.type] };

            if (learningAsset._id in newById) {
                delete newById[learningAsset._id];
            }

            if (learningAsset._id in newByType) {
                delete newByType[learningAsset._id];
            }

            if (learningAsset._id in newFilteredById) {
                delete newFilteredById[learningAsset._id];
            }

            return {
                ...state,
                [learningAsset.type]: newByType,
                byId: newById,
                loading: false,
                archivedById: newArchivedById,
                filteredById: newFilteredById
            };
        }

        case ACTIONS.PUT_UNARCHIVED_LEARNING_ASSET_SUCCESS: {
            const { learningAsset } = action.payload;
            newById = {
                ...state.byId,
                [learningAsset._id]: learningAsset
            };

            const newByType = {
                ...state[learningAsset.type],
                [learningAsset._id]: learningAsset
            };

            newArchivedById = {
                ...state.archivedById
            };

            const newFilteredById = {
                ...state.filteredById,
                [learningAsset._id]: learningAsset
            };

            if (learningAsset._id in newArchivedById) {
                delete newArchivedById[learningAsset._id];
            }

            return {
                ...state,
                [learningAsset.type]: newByType,
                byId: newById,
                loading: false,
                archivedById: newArchivedById,
                filteredById: newFilteredById
            };
        }

        case ACTIONS.GET_MANY_ARCHIVED_LEARNING_ASSETS: {
            const { learningAssets } = action.payload;

            newArchivedById = {
                ...state.archivedById
            };

            learningAssets.forEach((asset) => {
                newArchivedById[asset._id] = asset;
            });

            return {
                ...state,
                archivedById: newArchivedById
            };
        }

        case ACTIONS.CLEAR_SEARCHED_LEARNING_ASSETS: {
            return {
                ...state,
                filteredById: {},
                loading: false
            };
        }

        default:
            return state;
    }
};
